import React, { useState, useEffect, Fragment } from 'react';
import { useParams } from 'react-router-dom';
//*MUI
import {
  Box,
  Divider,
  FormGroup,
  FormControl,
  FormControlLabel,
  Checkbox,
} from '@mui/material';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

//*Redux
import { useDispatch, useSelector } from 'react-redux';
import action from '../../../Redux Store/actions';

//*files
import cssClasses from './SiteVisit.module.css';
import Button from '../../../Subcomponents/Button';
import AddSiteVisit from '../../../Modals/AddSiteVisit/AddSiteVisit';
import {
  getAllSiteVisits,
  getProjectByProjectName,
} from '../../../Services/SustenanceService';
import ViewSiteVisitDetails from '../../../Modals/ViewSiteVisitDetails/ViewSiteVisitDetails';
import SiteVisitIcon from '../../../Assets/Images/Common/NoSiteVisitsFound.svg';
import PlusIcon from '../../Icons/PlusIcon';
import DropDown from '../../../Subcomponents/DropDown';
import SearchBar from '../../../Subcomponents/Search';
import { debounce, findIndex, orderBy, sortBy } from 'lodash';
import checked from '../../../Assets/Images/Common/checked.svg';
import DateComponent from '../../../Subcomponents/DateComponent';
import { getAllCpForLaunch } from '../../../Services/ChannelPartner';
import { getUsers } from '../../../Services/Lead';
import { DataGrid } from '@mui/x-data-grid';
import { supabase } from '../../../supabaseClient';
import ProjectIcon from '../../../Assets/Images/Sustenance/ProjectIcon.svg';

const dataGridStyles = {
  '&.MuiDataGrid-root .MuiDataGrid-cell:focus': {
    outline: 'none',
  },
  border: '1px solid #EAECF0 !important',
  fontWeight: '400',
  fontSize: '1.4rem',
  lineHeight: '2rem',
  color: '#667085',
  fontFamily: 'Inter-Medium',
  borderRadius: '8px',
  '& div[data-colindex="1"]': {
    color: '#101828',
    fontWeight: '500',
  },
  '& .MuiDataGrid-virtualScrollerRenderZone': {
    '& .MuiDataGrid-row': {
      borderBottom: '1px solid #EAECF0',
      background: '#FFFFFF',
      /* Shadow/xl */

      // boxShadow: "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
      borderRadius: '1rem',

      //   "&:nth-of-type(2n+1)": { backgroundColor: "rgba(249, 250, 251, 1)" },
      //   backgroundColor: "#FFFFFF",
    },
    '& .MuiDataGrid-row.Mui-selected:hover': {
      borderBottom: '1px solid #EAECF0',
      backgroundColor: '#FFFFFF',
      // "&:nth-of-type(2n+1)": {
      //   backgroundColor: "rgba(249, 250, 251, 1)",
      // },
    },
  },
  '& .MuiDataGrid-iconSeparator ': {
    display: 'none',
  },
  '& .MuiDataGrid-columnHeader:hover': {
    '& .MuiDataGrid-menuIcon': {
      visibility: 'hidden',
    },
  },

  '&  .MuiDataGrid-columnHeaders': {
    background: '#F9FAFB',
    /* Gray/200 */
    border: '1px solid #EAECF0',
    /* Shadow/xl */
    // boxShadow:
    //   "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
    // borderRadius: "8px",

    marginBottom: '1rem',
    borderBottom: '6px solid #EAECF0',
  },
  '& .MuiDataGrid-columnSeparator': {
    display: 'none',
  },
  '& .MuiDataGrid-checkboxInput': {
    '& svg': {
      width: '2rem',
      height: '2rem',
      background: '#FFFFFF',
    },
  },
  // "& .MuiTablePagination-displayedRows": {
  //   display: "none",
  // },
  '& .MuiDataGrid-footerContainer': {
    '& .MuiTablePagination-displayedRows ': {
      display: 'none',
    },
    '& .MuiDataGrid-selectedRowCount': {
      visibility: 'hidden ',
    },
  },
  "&  [title='Sort']": {
    //visibility:"hidden",
    display: 'none',
    cursor: 'none',
  },
  "& [title='Go to previous page']": {
    borderRadius: '0',
    border: '1px solid #EAECF0',
    borderRadius: '0.8rem',
    marginRight: '0.5rem',
  },
  "& [title='Go to next page']": {
    borderRadius: '0',
    border: '1px solid #EAECF0',
    borderRadius: '0.8rem',
    marginRight: '0.5rem',
  },
  "& [title='Go to previous page']:after": {
    content: "'Previous'",
    marginLeft: '1rem',
  },
  "& [title='Go to next page']:before": {
    content: "'Next'",
    marginRight: '1rem',
  },
  '& .MuiDataGrid-columnHeader': {
    padding: '0 4rem',

    '&:focus': {
      outline: 'none',
    },
  },
  '&  .MuiDataGrid-row ': {
    maxHeight: '72px !important',
    minHeight: '72px !important',
  },
  '& .MuiDataGrid-cell': {
    padding: '0 4rem',
    minHeight: '72px !important',
    maxHeight: '72px !important',
    '&:focus': {
      outline: 'none',
    },
  },
  '& .MuiButtonBase-root': {
    fontSize: '1.6rem',
  },
  '& .MuiDataGrid-cell:focus-within': {
    outline: 'none !important',
  },
  '& .MuiDataGrid-cell': {
    padding: '0 2rem',
    minHeight: '72px !important',
    maxHeight: '72px !important',
    '&:focus': {
      outline: 'none',
    },
  },
  '& .MuiDataGrid-columnHeader': {
    padding: '0 1rem',

    '&:focus': {
      outline: 'none',
    },
  },
};
function SiteVisit() {
  let loggedInUser = {};

  loggedInUser = useSelector((state) => state.Auth.user);
  console.log(loggedInUser);
  const [ProjectData, setProjectData] = useState([]);

  const [AllSitesData, setAllSitesData] = useState([]);
  const [pageNumber, setPageNumber] = useState(0);
  const [pageSize, setPageSize] = useState(12);
  const [search, setSearch] = useState('');
  const [pageMaintain, setPageMaintain] = useState(0);
  const [noSiteVisitPresent, setNoSiteVisitPresent] = useState(null);
  const [ViewSiteData, setViewSiteData] = useState('');

  //*DropDowns
  const [drpDownSelectedVal, setDrpDownSelectedVal] = useState('Latest First');
  const [selectedCp, setSelectedCp] = useState([]);
  const [showDates, setShowDates] = useState(false);
  const [selectedSales, setSelectedSales] = useState([]);
  const [selectDates, setSelectDates] = useState([
    { label: 'StartDate', value: '' },
    { label: 'EndDate', value: '' },
  ]);
  const [selectedDates, setSelectedDates] = useState(null);
  const [TotalSiteVisits, setTotalSiteVisits] = useState(0);

  //*main-DropDown
  const [selectedListDropDown, setSelectedListDropDown] = useState([]);
  const [showDropDown, setShowDropDown] = useState(false);

  const [listOfDropDown, setListOfDropDown] = useState([
    { label: 'None', select: true },
    { label: 'CP', select: false },
    { label: 'SM', select: false },
    { label: 'Date', select: false },
  ]);

  //*CP-DropDown
  const [showAllCPDropDown, setShowAllCPDropDown] = useState(false);
  const [AllCPDropDown, setAllCPDropDown] = useState([]);

  //*SM-DropDown
  const [showAllSalesDropDown, setShowAllSalesDropDown] = useState(false);
  const [AllSalesDropDown, setAllSalesDropDown] = useState([]);

  //*search in filters
  const [DropDownCpSearch, setDropDownCpSearch] = useState('');
  const [DropdownSalesSearch, setDropDownSalesSearch] = useState('');

  const [helperText, setHelperText] = useState({
    startDate: '',
    endDate: '',
  });

  //*Modals
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = (event, reason) => {
    if (reason && reason === 'backdropClick') return;
    setOpen(false);
  };

  const [DropdownSearch, setDropDownSearch] = useState('');

  const [openViewDetails, setOpenViewDetails] = useState(false);
  const handleViewDetailsOpen = () => setOpenViewDetails(true);
  const handleViewDetailsClose = () => setOpenViewDetails(false);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(action.activeMenu('sitevisit'));
    getAllCp('');
    getAllUser('');
    getSiteVisitData();
  }, []);

  useEffect(() => {
    console.log('site visit before setting', AllSitesData);
  }, [AllSitesData]);

  const { projectId } = useParams();

  //*snapshot
  useEffect(() => {
    let updateUnitListener = supabase
      .from('SiteVisits')
      .on('UPDATE', (handleRecordUpdated) => {
        console.log(handleRecordUpdated);
        if (handleRecordUpdated.eventType === 'UPDATE') {
          getAllSitesFromServer(
            0,
            false,
            search,
            drpDownSelectedVal,
            selectedCp,
            selectedSales,
            selectDates,
            selectedDates
          );
        }
      })
      .subscribe((status) => {
        console.log('status: ', status);
      });
    return () => {
      if (updateUnitListener) {
        supabase.removeSubscription(updateUnitListener);
        updateUnitListener = null;
      }
    };
  }, []);

  useEffect(() => {
    console.log('Project-Id', projectId);
    getAllSitesFromServer(
      0,
      false,
      search,
      drpDownSelectedVal,
      selectedCp,
      selectedSales,
      selectDates,
      selectedDates
    );
  }, [projectId ]);

  const CpColumns = [
    {
      field: 'Site',
      headerName: 'Leads',
      width: 440,
      renderCell: (params) => {
        return (
          <Box className={cssClasses.SubContainer}>
            {params.row.sitevisiturl ? (
              <img
                style={{
                  width: '4rem',
                  height: '4rem',
                  objectFit: 'cover',
                  borderRadius: '50%',
                }}
                src={
                  process.env.REACT_APP_SUPABASE_BUCKET_PREFIX +
                  params.row.sitevisiturl
                }
                alt={''}
              />
            ) : (
              <img src={ProjectIcon} alt={''} />
            )}

            <Box>
              <Box className={cssClasses.BoldTitle} whiteSpace={'break-spaces'}>
                {params?.row?.leadname ? params?.row?.leadname : '-'}
              </Box>
              <Box>
                <Box
                  component={'span'}
                  className={cssClasses.semiBoldTitle}
                  whiteSpace={'break-spaces'}
                >
                  VJ
                  {params?.row?.leaddisplayid
                    ? params?.row?.leaddisplayid?.replace(
                        params?.row?.leaddisplayid?.substring(8, 12),
                        '-' + params?.row?.leaddisplayid?.substring(8, 12)
                      )
                    : '-'}
                </Box>
              </Box>
            </Box>
          </Box>
        );
      },
    },
    {
      field: 'Cp&Fos',
      headerName: 'Channel Partners and their FOS',
      width: 350,
      renderCell: (params) => {
        return (
          <Box className={cssClasses.SubContainer}>
            <Box>
              <Box className={cssClasses.BoldTitle}>
                CP :{' '}
                <Box
                  component={'span'}
                  className={cssClasses.semiBoldTitle}
                  whiteSpace={'break-spaces'}
                >
                  {' '}
                  {params?.row?.billingname ? params?.row?.billingname : '-'}
                </Box>
              </Box>
              <Box className={cssClasses.BoldTitle}>
                FOS :{' '}
                <Box
                  component={'span'}
                  className={cssClasses.semiBoldTitle}
                  whiteSpace={'break-spaces'}
                >
                  {params?.row?.fosname ? params?.row?.fosname : '-'}
                </Box>
              </Box>
            </Box>
          </Box>
        );
      },
    },
    {
      field: 'Sales',
      headerName: 'Sales Representative',
      width: 205,
      renderCell: (params) => {
        return (
          <Box className={cssClasses.SubContainer}>
            <Box className={cssClasses.BoldTitle} whiteSpace={'break-spaces'}>
              {params?.row?.username ? params?.row?.username : '-'}
            </Box>
          </Box>
        );
      },
    },
    {
      field: 'VisitDateTime',
      headerName: 'Visit Date & Time ',
      width: 300,
      renderCell: (params) => {
        return (
          <Box whiteSpace={'break-spaces'}>
            {new Date(params.row.sitevisitdate).toDateString()},{' '}
            {new Date(params.row.sitevisitdate).toLocaleTimeString([], {
              hour: '2-digit',
              minute: '2-digit',
            })}
          </Box>
        );
      },
    },
    {
      field: 'action',
      headerName: 'Action',
      width: 180,
      renderCell: (params) => {
        return (
          <Button
            style={{
              color: '#155EEF',
              backgroundColor: '#FFF',
              border: '1px solid #155EEF',
              fontSize: '1.4rem',
              lineHeight: '2rem',
            }}
            btnName={'View Details'}
            padding={'0.5rem 2.5rem'}
            clicked={() => {
              setViewSiteData(params.row);
              handleViewDetailsOpen();
            }}
          />
        );
      },
    },
  ];

  const debouncedFetchSearchData = debounce((e) => {
    setSearch(e.target.value);
    getAllSitesFromServer(
      pageNumber,
      false,
      e.target.value,
      drpDownSelectedVal,
      selectedCp,
      selectedSales,
      selectDates,
      selectedDates
    );
  }, 800);

  function getAllSitesFromServer(
    pageNumber,
    merge,
    search,
    drpDownSelectedVal,
    selectedCp,
    selectedSales,
    selectDates,
    selectedDates
  ) {
    getAllSiteVisits(
      projectId,
      pageNumber * pageSize,
      pageNumber * pageSize + pageSize - 1,
      search,
      drpDownSelectedVal,
      selectedCp,
      selectedSales,
      selectDates,
      selectedDates
    )
      .then((resp) => {
        console.log(resp);
        setTotalSiteVisits(resp.count);
        if (resp.count > 0) {
          setNoSiteVisitPresent(true);
        } else {
          setNoSiteVisitPresent(false);
        }
        const SiteVisitArr = resp.data.map((el, index) => ({
          ...el,
          id: el.sitevisitid,
          index: index,
          sitevisitdate: el.sitevisitdate,
        }));
       
        if (merge) {
          setAllSitesData((pre) => [...pre , ...SiteVisitArr]);
        } else {
          setAllSitesData([...SiteVisitArr]);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function getMoreData(passPageNumber) {
    console.log('pass=page-number', passPageNumber);
    setPageNumber(passPageNumber);
    getAllSitesFromServer(
      passPageNumber,
      true,
      search,
      drpDownSelectedVal,
      selectedCp,
      selectedSales,
      selectDates,
      selectedDates
    );
  }

  function getSiteVisitData() {
    getProjectByProjectName(projectId)
      .then((res) => {
        console.log('Projects-data', res);
        setProjectData(res.data[0]);
      })
      .catch((err) => {
        console.error('getProjectByProjectName', err);
      });
  }


  function returnRes(value) {
    if (value === true) {
      getAllSitesFromServer(
        0,
        false,
        search,
        drpDownSelectedVal,
        selectedCp,
        selectedSales,
        selectDates,
        selectedDates
      );
    }
  }

  function getAllCp(search) {
    getAllCpForLaunch(search)
      .then((resp) => {
        let tempArray = AllCPDropDown;
        tempArray = resp.data.map((el, index) => {
          return {
            label: el.billingName,
            value: false,
            id: el.cpId,
          };
        });
        const sortedCp = orderBy(
          tempArray,
          [(cp) => cp.label.toLowerCase()],
          ['asc']
        );
        setAllCPDropDown(sortedCp);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function getAllUser(search) {
    getUsers(search)
      .then((resp) => {
        let tempArray = AllSalesDropDown;
        tempArray = resp.data.map((el, index) => {
          return {
            label: el.name,
            value: false,
            id: el.userId,
          };
        });
        const sortedArray = orderBy(
          tempArray,
          [(user) => user.label.toLowerCase()],
          ['asc']
        );
        setAllSalesDropDown(sortedArray);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const debouncedFetchDropDownSearch1 = debounce((e) => {
    if (showAllCPDropDown) {
      setDropDownCpSearch(e.target.value);
      getAllCp(e.target.value);
    }
  }, 800);

  const debouncedFetchDropDownSearch2 = debounce((e) => {
    if (showAllSalesDropDown) {
      setDropDownSalesSearch(e.target.value);
      getAllUser(e.target.value);
    }
  }, 800);

  function clearFilters() {
    setAllSitesData([]);
    setSelectedListDropDown([]);
    setListOfDropDown((pre) => {
      pre = pre.map((m) => ({
        ...m,
        select: false,
      }));
      pre[0].select = true;
      return [...pre];
    });
    setAllCPDropDown((pre) => {
      pre = pre.map((m) => ({
        ...m,
        value: false,
      }));
      return [...pre];
    });
    setAllSalesDropDown((pre) => {
      pre = pre.map((m) => ({
        ...m,
        value: false,
      }));
      return [...pre];
    });

    setSelectedDates(null);
    setShowDropDown(false);
    setShowAllCPDropDown(false);
    setShowAllSalesDropDown(false);
    setShowDates(false);
    setSelectedCp([]);
    setSelectedSales([]);
    setDropDownCpSearch('');
    setDropDownSalesSearch('');
    setSelectDates((pre) => {
      pre[0].value = '';
      pre[1].value = '';
      return { ...pre };
    });
  }

  return (
    <div className='pageWrapper'>
      <div className={cssClasses.wrapperHeader}>
        <Box>
          <Box className={cssClasses.HeaderTitle}>
            {ProjectData?.projectName}
          </Box>
          <Box className={cssClasses.SubTitle}>
            {ProjectData?.addressLine1},{ProjectData?.addressLine2},
            {ProjectData?.addressLine3}
          </Box>
        </Box>
        {loggedInUser?.roleId?.accessibleTabs?.Sustenance['Site Visit'][
          'Add Site Visit'
        ]?.isAccessible && (
          <Box>
            <Button
              style={{
                color: '#fff',
                backgroundColor: '#1570EF',
                fontSize: '1.4rem',
                lineHeight: '2rem',
                fontFamily: 'Roboto-Regular',
              }}
              padding={'0.8rem 2.6rem'}
              btnName={'Add Site Visit'}
              btnIcon={<PlusIcon />}
              iconPosition={'left'}
              clicked={handleOpen}
            />
          </Box>
        )}
      </div>
      <Divider />

      <div className={cssClasses.wrapperFilters}>
        <div className={cssClasses.containerFilterSortBy}>
          <Box className={cssClasses.countTitle} mt={3}>
            {TotalSiteVisits} Site Visits
          </Box>
          <div className={cssClasses.wrapperFilter}>
            <div className={cssClasses.filterTitle}>Filter by</div>
            <div className={cssClasses.wrapperDropDown}>
              <div
                className={cssClasses.wrapperCustomiseDropDown}
                onClick={(e) => {
                  e.stopPropagation();
                  setShowDropDown(!showDropDown);
                }}
              >
                <div className={cssClasses.dropDownLabel}>
                  <span className={cssClasses.dropDownLabelValue}>
                    {selectedListDropDown.join()}
                  </span>
                  {selectedListDropDown.length === 0 && (
                    <span className={cssClasses.dropDownLabelValue}>None</span>
                  )}
                </div>
                <span>
                  {' '}
                  <KeyboardArrowDownIcon className={cssClasses.dropDownIcon} />
                </span>
              </div>
              {showDropDown && (
                <ClickAwayListener
                  onClickAway={() => {
                    setShowDropDown(false);
                  }}
                >
                  <div className={cssClasses.containerCustomiseDropDown}>
                    <div className={cssClasses.wrapperSelectAndCheckbox}>
                      <div className={cssClasses.wrapperEachSelect}>
                        {listOfDropDown.map((each, index) => {
                          return (
                            <div
                              className={
                                each.select
                                  ? cssClasses.selectedVal
                                  : cssClasses.containerEachSelect
                              }
                            >
                              <div
                                className={cssClasses.eachSelect}
                                onClick={() => {
                                  setListOfDropDown((pre) => {
                                    pre = pre.map((m) => ({
                                      ...m,
                                      select: false,
                                    }));
                                    // pre[index].select = true;
                                    return [...pre];
                                  });

                                  if (selectedDates != null) {
                                    let indexOfMainList = findIndex(
                                      listOfDropDown,
                                      ({ label }) => label === 'Date'
                                    );
                                    setListOfDropDown((pre) => {
                                      pre[indexOfMainList].select = true;
                                      return [...pre];
                                    });
                                  }
                                  AllCPDropDown.forEach((el) => {
                                    if (el.value) {
                                      let indexOfMainList = findIndex(
                                        listOfDropDown,
                                        ({ label }) => label === 'CP'
                                      );
                                      setListOfDropDown((pre) => {
                                        pre[indexOfMainList].select = true;
                                        return [...pre];
                                      });
                                    }
                                  });
                                  AllSalesDropDown.forEach((el) => {
                                    if (el.value) {
                                      let indexOfMainList = findIndex(
                                        listOfDropDown,
                                        ({ label }) => label === 'SM'
                                      );
                                      setListOfDropDown((pre) => {
                                        pre[indexOfMainList].select = true;
                                        return [...pre];
                                      });
                                    }
                                  });
                                  if (each.label === 'None') {
                                    setSelectedListDropDown([]);
                                    setSelectedCp([]);
                                    setSelectedSales([]);
                                    setSelectedDates(null);
                                    setSelectDates((pre) => {
                                      pre[0].value = '';
                                      pre[1].value = '';
                                      return { ...pre };
                                    });
                                    setListOfDropDown((pre) => {
                                      pre = pre.map((m) => ({
                                        ...m,
                                        select: false,
                                      }));
                                      pre[0].select = true;
                                      return [...pre];
                                    });
                                    if (
                                      selectDates.startDate === '' ||
                                      selectDates.endDate === ''
                                    ) {
                                      setListOfDropDown((pre) => {
                                        pre[1].select = false;
                                        return [...pre];
                                      });
                                    }
                                    AllCPDropDown.forEach((el) => {
                                      el.value = false;
                                    });
                                    AllSalesDropDown.forEach((el) => {
                                      el.value = false;
                                    });

                                    setShowAllCPDropDown(false);
                                    setShowAllSalesDropDown(false);
                                    setShowDates(false);
                                  } else if (each.label === 'CP') {
                                    setTimeout(() => {
                                      let _val = document.getElementById(
                                        'input-with-icon-textfield DropDownLeadCpSearch'
                                      );
                                      if (_val) {
                                        _val.value = DropDownCpSearch;
                                      }
                                    }, 100);
                                    setShowAllCPDropDown(true);
                                    setShowAllSalesDropDown(false);
                                    setShowDates(false);
                                  } else if (each.label === 'SM') {
                                    setTimeout(() => {
                                      let _val = document.getElementById(
                                        'input-with-icon-textfield DropDownLeadSalesSearch'
                                      );
                                      if (_val) {
                                        _val.value = DropdownSalesSearch;
                                      }
                                    }, 100);
                                    setShowAllCPDropDown(false);
                                    setShowAllSalesDropDown(true);
                                    setShowDates(false);
                                  } else if (each.label === 'Date') {
                                    setShowAllCPDropDown(false);
                                    setShowAllSalesDropDown(false);
                                    setShowDates(true);
                                  }
                                }}
                              >
                                {each.label}
                              </div>
                              {each.select && (
                                <img
                                  src={checked}
                                  alt={'checked'}
                                  style={{ marginRight: '2rem' }}
                                />
                              )}
                            </div>
                          );
                        })}
                      </div>
                      <div className={cssClasses.wrapperCheckbox1}>
                        {showAllCPDropDown && (
                          <Box width={'100%'} mb={2}>
                            <SearchBar
                              id={'DropDownLeadCpSearch'}
                              placeholder={'Search'}
                              search={debouncedFetchDropDownSearch1}
                              width='100%'
                            />
                          </Box>
                        )}
                        {showAllSalesDropDown && (
                          <Box width={'100%'} mb={2}>
                            <SearchBar
                              id={'DropDownLeadSalesSearch'}
                              placeholder={'Search'}
                              search={debouncedFetchDropDownSearch2}
                              width='100%'
                            />
                          </Box>
                        )}
                        <div className={cssClasses.wrapperCheckbox}>
                          {showAllCPDropDown && (
                            <>
                              {AllCPDropDown?.length > 0 ? (
                                AllCPDropDown.map((each, index) => {
                                  return (
                                    <FormGroup>
                                      <FormControlLabel
                                        sx={[
                                          {
                                            '& .MuiTypography-root': {
                                              fontFamily:
                                                'Inter-Medium !important',
                                              fontStyle: 'normal',
                                              fontWeight: '400',
                                              fontSize: '1.6rem !important',
                                              lineHeight: '2.4rem !important',
                                              color: '#101828',
                                              textTransform: 'capitalize',
                                            },
                                          },
                                        ]}
                                        checked={each.value}
                                        onChange={(e) => {
                                          console.log(e.target.checked);
                                          if (e.target.checked) {
                                            setAllCPDropDown((pre) => {
                                              pre[index].value =
                                                e.target.checked;
                                              selectedCp.push(each.id);
                                              return [...pre];
                                            });
                                          } else {
                                            setAllCPDropDown((pre) => {
                                              pre[index].value =
                                                e.target.checked;
                                              return [...pre];
                                            });
                                            setSelectedCp(
                                              selectedCp.filter(
                                                (cp) => cp !== each.id
                                              )
                                            );
                                          }
                                          let checkCpSelected =
                                            AllCPDropDown.filter(
                                              ({ value }) => value === true
                                            );
                                          if (checkCpSelected.length > 0) {
                                            setListOfDropDown((pre) => {
                                              pre[1].select = true;
                                              return [...pre];
                                            });
                                            if (
                                              selectedListDropDown.find(
                                                (value) => value === 'CP'
                                              ) === undefined
                                            ) {
                                              setSelectedListDropDown((pre) => {
                                                return [...pre, 'CP'];
                                              });
                                            }
                                          } else {
                                            setListOfDropDown((pre) => {
                                              pre[1].select = false;
                                              return [...pre];
                                            });
                                            setSelectedListDropDown((pre) => [
                                              ...pre.filter(
                                                (value) => value !== 'CP'
                                              ),
                                            ]);
                                          }
                                        }}
                                        control={
                                          <Checkbox
                                            sx={{
                                              '& .MuiSvgIcon-root': {
                                                fontSize: 28,
                                              },
                                            }}
                                          />
                                        }
                                        label={each.label}
                                      />
                                    </FormGroup>
                                  );
                                })
                              ) : (
                                <div className={cssClasses.label}>
                                  No CP Found
                                </div>
                              )}
                            </>
                          )}
                          {showAllSalesDropDown && (
                            <>
                              {AllSalesDropDown?.length > 0 ? (
                                AllSalesDropDown.map((each, index) => {
                                  return (
                                    <FormGroup>
                                      <FormControlLabel
                                        sx={[
                                          {
                                            '& .MuiTypography-root': {
                                              fontFamily:
                                                'Inter-Medium !important',
                                              fontStyle: 'normal',
                                              fontWeight: '400',
                                              fontSize: '1.6rem !important',
                                              lineHeight: '2.4rem !important',
                                              /* identical to box height, or 150% */

                                              /* Gray/900 */

                                              color: '#101828',
                                            },
                                          },
                                        ]}
                                        checked={each.value}
                                        onChange={(e) => {
                                          if (e.target.checked) {
                                            setAllSalesDropDown((pre) => {
                                              pre[index].value =
                                                e.target.checked;
                                              selectedSales.push(each.id);
                                              return [...pre];
                                            });
                                          } else {
                                            setAllSalesDropDown((pre) => {
                                              pre[index].value =
                                                e.target.checked;
                                              return [...pre];
                                            });
                                            setSelectedSales(
                                              selectedSales.filter(
                                                (id) => id !== each.id
                                              )
                                            );
                                          }
                                          let checkSalesSelected =
                                            AllSalesDropDown.filter(
                                              ({ value }) => value === true
                                            );
                                          if (checkSalesSelected.length > 0) {
                                            setListOfDropDown((pre) => {
                                              pre[2].select = true;
                                              return [...pre];
                                            });
                                            if (
                                              selectedListDropDown.find(
                                                (value) => value === 'SM'
                                              ) === undefined
                                            ) {
                                              setSelectedListDropDown((pre) => {
                                                console.log('pre: ', pre);
                                                return [...pre, 'SM'];
                                              });
                                            }
                                          } else {
                                            setListOfDropDown((pre) => {
                                              pre[2].select = false;
                                              return [...pre];
                                            });
                                            setSelectedListDropDown((pre) => [
                                              ...pre.filter(
                                                (value) => value !== 'SM'
                                              ),
                                            ]);
                                          }
                                        }}
                                        control={
                                          <Checkbox
                                            sx={{
                                              '& .MuiSvgIcon-root': {
                                                fontSize: 28,
                                              },
                                            }}
                                          />
                                        }
                                        label={each.label}
                                      />
                                    </FormGroup>
                                  );
                                })
                              ) : (
                                <div className={cssClasses.label}>
                                  No SM User Found
                                </div>
                              )}
                            </>
                          )}
                          {showDates && (
                            <div>
                              <div className={cssClasses.dateDivider}>
                                <div className={cssClasses.label}>
                                  Start Date
                                </div>
                                <DateComponent
                                  value={selectDates[0].value}
                                  minDate={'1 Jan'}
                                  onChangeDate={(value) => {
                                    console.log(value);
                                    setSelectedDates('notNull');
                                    setSelectDates((pre) => {
                                      pre[0].value = value;
                                      return { ...pre };
                                    });
                                    setHelperText((pre) => {
                                      pre.endDate = '';
                                      return { ...pre };
                                    });
                                  }}
                                  helperText={helperText.startDate}
                                ></DateComponent>
                              </div>
                              <div>
                                <div className={cssClasses.label}>End Date</div>
                                <DateComponent
                                  value={selectDates[1].value}
                                  minDate={'1 Jan'}
                                  onChangeDate={(value) => {
                                    setSelectedDates('notNull');
                                    console.log(selectDates[0].value, value);
                                    if (selectDates[0].value === '') {
                                      setHelperText((pre) => {
                                        pre.endDate =
                                          'Please select start date first';
                                        return { ...pre };
                                      });
                                    } else {
                                      if (selectDates[0].value > value) {
                                        setHelperText((pre) => {
                                          pre.endDate =
                                            'Select End Date Greater than start Date';
                                          return { ...pre };
                                        });
                                      } else {
                                        setSelectDates((pre) => {
                                          pre[1].value = value;
                                          return { ...pre };
                                        });
                                        setHelperText((pre) => {
                                          pre.endDate = '';
                                          return { ...pre };
                                        });
                                        setListOfDropDown((pre) => {
                                          pre[3].select = true;
                                          return [...pre];
                                        });
                                        if (
                                          selectedListDropDown.find(
                                            (value) => value === 'Date'
                                          ) === undefined
                                        ) {
                                          selectedListDropDown.push('Date');
                                        }
                                      }
                                    }
                                  }}
                                  helperText={helperText.endDate}
                                ></DateComponent>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className={cssClasses.wrapperDropDownButtons}>
                      <div>
                        <Button
                          style={{
                            color: '#344054',
                            backgroundColor: '#ffffff',
                            fontSize: '1.4rem',
                            lineHeight: '2rem',
                          }}
                          padding={'0.8rem'}
                          btnName={'Clear'}
                          clicked={() => {
                            clearFilters();
                            getAllSitesFromServer(
                              0,
                              false,
                              search,
                              drpDownSelectedVal,
                              [],
                              [],
                              selectDates,
                              null
                            );
                          }}
                        />
                      </div>
                      <div>
                        <Button
                          style={{
                            color: '#ffffff',
                            backgroundColor: '#1570EF',
                            fontSize: '1.4rem',
                            lineHeight: '2rem',
                          }}
                          padding={'0.8rem'}
                          btnName={'Apply'}
                          clicked={() => {
                            if (
                              selectDates[1].value === '' &&
                              selectedDates !== null
                            ) {
                              setHelperText((pre) => {
                                pre.endDate = 'Please Select end Date';
                                return { ...pre };
                              });
                              setShowDates(true);
                            } else {
                              setHelperText((pre) => {
                                pre.endDate = '';
                                return { ...pre };
                              });
                              setShowDates(false);
                            }
                            setShowAllCPDropDown(false);
                            setShowAllSalesDropDown(false);

                            setShowDropDown(false);
                            console.log(helperText);
                            if (
                              helperText.startDate === '' &&
                              helperText.endDate === ''
                            ) {
                              setAllSitesData([]);
                              setShowDropDown(false);
                              getAllSitesFromServer(
                                0,
                                false,
                                search,
                                drpDownSelectedVal,
                                selectedCp,
                                selectedSales,
                                selectDates,
                                selectedDates
                              );
                            } else {
                              setShowDropDown(true);
                            }
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </ClickAwayListener>
              )}
            </div>
          </div>
          <div className={cssClasses.wrapperSortDropDown}>
            <div className={cssClasses.filterTitle}>Sort by</div>
            <div>
              <DropDown
                list={[
                  'Name Ascending',
                  'Name Descending',
                  'Latest First',
                  'Oldest First',
                ]}
                selectedValue={drpDownSelectedVal}
                onChangeSelect={(_value) => {
                  setDrpDownSelectedVal(_value);
                  setAllSitesData([]);
                  getAllSitesFromServer(
                    0,
                    false,
                    search,
                    _value,
                    selectedCp,
                    selectedSales,
                    selectDates,
                    selectedDates
                  );
                }}
                placeHolder={'Select'}
                //style.color is placeHolder's color
                style={{ selectedColor: '#175CD3', background: '#E8F0FE' }}
                helperText={''}
              />
            </div>
          </div>
        </div>
        <div className={cssClasses.wrapperSearchBar}>
          <SearchBar
            id={'StudentSearch'}
            value={search}
            placeholder={'Search By LeadName'}
            search={debouncedFetchSearchData}
            width='100%'
          />
        </div>
      </div>
      {noSiteVisitPresent === true && (
        <Box className={cssClasses.GridWrapper}>
          {/* <Datagrid
            rows={AllSitesData}
            columns={CpColumns}
            hideFooter={false}
            pageChanged={pageChanged}
          /> */}
          <DataGrid
            rows={AllSitesData}
            columns={CpColumns}
            pageSize={10}
            rowsPerPageOptions={[10]}
            page={pageMaintain}
            onPageChange={(_page) => {
              console.log(_page);
              setPageMaintain(_page);
              if (pageNumber < _page) {
                getMoreData(_page);
                // setPageNumber(_page);
              }
            }}
            sx={[dataGridStyles]}
          />
        </Box>
      )}

      {noSiteVisitPresent === false && (
        <Box>
          <Box width={'100%'} height={'100%'}>
            <Box className={cssClasses.noDataMsg}>
              <Box className={cssClasses.emptyIcon}>
                <img src={SiteVisitIcon} alt='No Site Visits Yet' />
              </Box>
              <Box className={cssClasses.emptyTitle}>
                No Site visit records were found
              </Box>
              {loggedInUser?.roleId?.accessibleTabs?.Sustenance['Site Visit'][
                'Add Site Visit'
              ]?.isAccessible && (
                <div className={cssClasses.emptySubTitle}>
                  To add a new site visit, click on
                  <div className={cssClasses.addLeadBtn}>
                    <Button
                      style={{
                        color: '#fff',
                        backgroundColor: '#175CD3',
                        fontSize: '1.6rem',
                        lineHeight: '2.4rem',
                      }}
                      btnName={'Add Site Visit'}
                      clicked={handleOpen}
                      btnIcon={<PlusIcon />}
                      iconPosition={'left'}
                    >
                      {' '}
                    </Button>
                  </div>
                </div>
              )}
            </Box>
          </Box>
        </Box>
      )}

      {open && (
        <AddSiteVisit
          open={open}
          handleClose={handleClose}
          modalType={'SustenanceSiteVisit'}
          returnRes={returnRes}
        />
      )}

      {openViewDetails && (
        <ViewSiteVisitDetails
          open={openViewDetails}
          handleClose={handleViewDetailsClose}
          data={ViewSiteData}
        />
      )}
    </div>
  );
}

export default SiteVisit;
